<template>
	<div class="wrapperddiv">
		<el-card class="box-card">
			<el-row type="flex" justify="end">
				<el-button-group>
					<el-button type="danger" @click="delSelectDialogVisible=true">区间批量删除</el-button>
				</el-button-group>
				<el-upload class="upload-demo" action="" :on-change="handleChange" :show-file-list="false"
					:auto-upload="false">
					<el-button type="primary">导入excel文件</el-button>
				</el-upload>
				<el-button-group>
					<!-- 		<el-button type="primary" @click="exportTableData">导出表格数据</el-button>
			<el-button type="primary" @click="exportSelectData">导出选中的行数据</el-button> -->
				</el-button-group>
			</el-row>
			<el-divider></el-divider>
			<el-row :gutter="30" style="display: flex;">
				<el-col :span="1">
					<el-button type="text" style="color: black;">港区:</el-button>
				</el-col>
				<el-col :span="5">
					<el-select v-model="queryInfo.dock" filterable placeholder="请选择" clearable>
						<el-option v-for="item in dockList" :key="item.dock" :label="item.dock" :value="item.dock">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="2">
					<el-button type="text" style="color: black;">门点地址:</el-button>
				</el-col>
				<el-col :span="5">
					<el-select v-model="queryInfo.trailer_door_point" filterable placeholder="请选择" clearable>
						<el-option v-for="item in trailer_door_pointList" :key="item.trailer_door_point"
							:label="item.trailer_door_point" :value="item.trailer_door_point">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="2">
					<el-button type="text" style="color: black;">生效日:</el-button>
				</el-col>
				<el-col :span="5">
					<el-date-picker v-model="queryInfo.Sxvalue" type="datetimerange" :picker-options="pickerOptions"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" unlink-panels
						:clearable="false">
					</el-date-picker>
				</el-col>
				<el-col :span="5" style="margin-left: 150px;">
					<el-button type="primary" @click="this.initListFn">查询</el-button>
				</el-col>
			</el-row>
			<el-divider></el-divider>
			<div slot="header" class="clearfix header-box">
				<span>内陆拖车数据库</span>
			</div>
			<!-- 表格区域 -->
			<el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" :data="dataList" border stripe
				ref="tableDataRef" row-key="id" :header-cell-style="{ 'background':'#E9E9E9','color':'#000000' }"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" :reserve-selection="true" width="55">
				</el-table-column>
				<el-table-column label="序号" type="index">
				</el-table-column>
				<el-table-column label="ID" prop="id"></el-table-column>
				<el-table-column label="港区" prop="dock" width="150px"></el-table-column>
				<el-table-column label="门点地址" prop="trailer_door_point" width="150px"></el-table-column>
				<el-table-column label="20GP(T0)" prop="20GP_T0"></el-table-column>
				<el-table-column label="40GP(T0)" prop="40GP_T0"></el-table-column>
				<el-table-column label="40HQ(T0)" prop="40HQ_T0"></el-table-column>
				<el-table-column label="20GP(T1)" prop="20GP_T1"></el-table-column>
				<el-table-column label="40GP(T1)" prop="40GP_T1"></el-table-column>
				<el-table-column label="40HQ(T1)" prop="40HQ_T1"></el-table-column>
				<el-table-column label="20GP(T2)" prop="20GP_T2"></el-table-column>
				<el-table-column label="40GP(T2)" prop="40GP_T2"></el-table-column>
				<el-table-column label="40HQ(T2)" prop="40HQ_T2"></el-table-column>
				<el-table-column label="生效日" prop="valid_fm" width="150px">
					<template slot-scope="scope">
						{{scope.row.valid_fm | fmtdate}}
					</template>
				</el-table-column>
				<el-table-column label="失效日" prop="valid_to" width="150px">
					<template slot-scope="scope">
						{{scope.row.valid_to | fmtdate}}
					</template>
				</el-table-column>
				<el-table-column label="暂停接货" prop="yes_no"></el-table-column>
				<el-table-column label="备注" prop="remark" width="600px" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column label="更新日期" prop="update_time" width="100px"></el-table-column>
				<el-table-column label="操作" width="150px" fixed="right">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="updateFn(scope.row.id)">修改</el-button>
						<el-button type="danger" size="mini" @click="removeFn(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryInfo.pagenum" :page-sizes="[10, 50, 100, 200]" :page-size="queryInfo.pagesize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>



		<el-dialog :lock-scroll="false" title="修改" :visible.sync="editDialogVisible" width="90%"
			@close="editDialogClosed" :close-on-click-modal="false" top="5vh">
			<el-form ref="editFormRef" :model="editForm" label-width="100px">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="港区" prop="dock">
							<el-input v-model="editForm.dock"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="门点地址" prop="trailer_door_point">
							<el-input v-model="editForm.trailer_door_point"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="20GP(T0)" prop="20GP_T0">
							<el-input v-model="editForm['20GP_T0']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="40GP(T0)" prop="40GP_T0">
							<el-input v-model="editForm['40GP_T0']"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="40HQ(T0)" prop="40HQ_T0">
							<el-input v-model="editForm['40HQ_T0']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="20GP(T1)" prop="20GP_T1">
							<el-input v-model="editForm['20GP_T1']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="40GP(T1)" prop="40GP_T1">
							<el-input v-model="editForm['40GP_T1']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="40HQ(T1)" prop="40HQ_T1">
							<el-input v-model="editForm['40HQ_T1']"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="20GP(T2)" prop="20GP_T2">
							<el-input v-model="editForm['20GP_T2']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="40GP(T2)" prop="40GP_T2">
							<el-input v-model="editForm['40GP_T2']"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="40HQ(T2)" prop="40HQ_T2">
							<el-input v-model="editForm['40HQ_T2']"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="生效日" prop="valid_fm">
							<el-input v-model="editForm.valid_fm"></el-input>
						</el-form-item>
					</el-col>
				</el-row>




				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item label="失效日" prop="valid_to">
							<el-input v-model="editForm.valid_to"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="暂停接货" prop="yes_no">
							<el-input v-model="editForm.yes_no"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="editForm.remark" type="textarea"></el-input>
						</el-form-item>
					</el-col>

				</el-row>











			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="editConfirm">确定修改</el-button>
			</span>
		</el-dialog>













		<el-dialog :lock-scroll="false" title="区间批量删除" :visible.sync="delSelectDialogVisible" width="50%"
			@close="delSelectDialogClosed" :close-on-click-modal="false">
			<el-form ref="delSelectFormRef" :model="delSelectForm" label-width="100px">
				<el-row :gutter="20">
					<el-col :span="2">
						<el-button type="text" style="color: black;">选择ID区间:</el-button>
					</el-col>
					<el-col :span="9">
						<el-form-item prop="start">
							<el-input v-model="delSelectForm.start" type="number"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="1">
						<el-button type="text" style="color: black;">到</el-button>
					</el-col>
					<el-col :span="9" style="margin-left: -95px;">
						<el-form-item prop="end">
							<el-input v-model="delSelectForm.end" type="number"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="delSelectDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="delSelectConfirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	//表格导入依赖
	import XLSX from 'xlsx'
	import moment from 'moment';
	export default {
		data() {
			return {
				dockList: [],
				trailer_door_pointList: [],
				loading: false,
				fileContent: '',
				file: '',
				data: '',
				//选中行导出的值
				selectionList: [],
				multipleSelection: [],
				queryInfo: {
					Sxvalue: [new Date(Date.now() - 365 * 24 * 60 * 60 * 1000), new Date(Date.now() + 365 * 24 * 60 * 60 *
						1000)],
					dock: '',
					trailer_door_point: '',
					//当前的页数
					pagenum: 1,
					//当前每页显示多少条数据
					pagesize: 10,
				},
				total: 0,
				//日期
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				dataList: [], // 数据列表
				//区间批量删除
				delSelectDialogVisible: false,
				delSelectForm: {
					start: '',
					end: ''
				},

				editDialogVisible: false,
				editForm: {}

			}
		},

		created() {
			this.initListFn()
		},
		methods: {
			//导出表格数据
			exportTableData() {
				// 获取dom元素（2种方式）
				let table = this.$refs.tableDataRef.$el
				let sheet = XLSX.utils.table_to_sheet(table)
				let book = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(book, sheet, "sheet1")
				XLSX.writeFile(book, `lclFreight.xls`)
			},
			//导出行数据
			//监听复选框选中的值
			handleSelectionChange(val) {
				this.selectionList = val
				//console.log(this.selectionList)
				let arryVal = val.map((item) => {
					return item.id
				})
				this.multipleSelection = arryVal;
				//console.log(this.multipleSelection)
			},
			exportSelectData() {
				// 对选择的表格数据处理：添加标题
				let arr = this.selectionList.map(item => {
					return {
						ID: item.id,
						港区: item.dock,
						门点地址: item.trailer_door_point,
						['20GP(T0)']: item['20GP_T0'],
						['40GP(T0)']: item['40GP_T0'],
						['40HQ(T0)']: item['40HQ_T0'],
						['20GP(T1)']: item['20GP_T1'],
						['40GP(T1)']: item['40GP_T1'],
						['40HQ(T1)']: item['40HQ_T1'],
						['20GP(T2)']: item['20GP_T2'],
						['40GP(T2)']: item['40GP_T2'],
						['40HQ(T2)']: item['40HQ_T2'],
						生效日: item.valid_fm,
						失效日: item.valid_to,
						备注: item.remark,
					}
				})
				// 将json数据变为sheet数据
				// json_to_sheet: 将一个由对象组成的数组转成sheet；
				let sheet = XLSX.utils.json_to_sheet(arr)
				// 新建表格
				let book = XLSX.utils.book_new()
				// 在表格中插入一个sheet
				XLSX.utils.book_append_sheet(book, sheet, "sheet1")
				// 通过xlsx的writeFile方法将文件写入
				XLSX.writeFile(book, `lclFreight.xls`)
			},


			//导入功能*****************************************************
			// 核心部分代码(handleChange 和 importfile)
			handleChange(file, fileList) {
				this.fileContent = file.raw
				const fileName = file.name
				const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
				if(file.size / 1024 /1024 > 2){
				return	this.$message({
						type: 'warning',
						message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
					})
				}
				
				if (this.fileContent) {
					if (fileType === 'xlsx' || fileType === 'xls') {
						this.importfile(this.fileContent)
					} else {
						this.$message({
							type: 'warning',
							message: '附件格式错误，请重新上传！'
						})
					}
				} else {
					this.$message({
						type: 'warning',
						message: '请上传附件！'
					})
				}
			},
			importfile(obj) {
				const reader = new FileReader()
				const _this = this
				reader.readAsArrayBuffer(obj)
				reader.onload = async function() {
					const buffer = reader.result
					const bytes = new Uint8Array(buffer)
					const length = bytes.byteLength
					let binary = ''
					for (let i = 0; i < length; i++) {
						binary += String.fromCharCode(bytes[i])
					}
					const XLSX = require('xlsx')
					const wb = XLSX.read(binary, {
						type: 'binary',
						cellDates: true
					})
					const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
					this.data = [...outdata]
					console.log(this.data)
					const arr = []
					this.data.map(v => {
						const obj = {}
						obj.id = v['ID']
						obj.dock = v['港区']
						obj.trailer_door_point = v['门点地址']
						obj['20GP_T0'] = v['20GP(T0)']
						obj['40GP_T0'] = v['40GP(T0)']
						obj['40HQ_T0'] = v['40HQ(T0)']
						obj['20GP_T1'] = v['20GP(T1)']
						obj['40GP_T1'] = v['40GP(T1)']
						obj['40HQ_T1'] = v['40HQ(T1)']
						obj['20GP_T2'] = v['20GP(T2)']
						obj['40GP_T2'] = v['40GP(T2)']
						obj['40HQ_T2'] = v['40HQ(T2)']
						obj.valid_fm = v['生效日'] = moment(v['生效日']).format('YYYY-MM-DD')
						obj.valid_to = v['失效日'] = moment(v['失效日']).format('YYYY-MM-DD')
						obj.yes_no = v['暂停接货']
						obj.remark = v['备注']
						obj.update_time = v['更新日期'] = moment(v['更新日期']).format('YYYY-MM-DD')
						//console.log(obj)
						arr.push(obj)
					})
					console.log(arr)
					// //后端请求数据
					// //这里不能用this，用_this
					//数据格式化数组对象转成(),(),()
					let str = arr.reduce((total, item, index) => {
						//累加三个逗号
						if (index != 0) {
							total += ','
						}
						total += '("' + encodeURIComponent(Object.values(item).join('","')) + '")'
						return total
					}, "")
					// //方法二，以''规则分割
					// let str = arr.reduce((total,item,index)=>{
					// 						 //累加三个逗号
					//     if(index!=0){total+=','}
					//     total+="('"+ encodeURIComponent(Object.values(item).join("','"))  +"')"
					//     return total
					// },'')


					let datainfo = {
						infoString: decodeURIComponent(str)
					}

					const {
						data: res
					} = await _this.$http.addMoreTrailer({
						data: datainfo
					})
					if (res.status !== 0) {
						return _this.$message.error(res.message)
					}

					_this.$message.success('导入成功！')
					setTimeout(() => {
						window.location.reload()
					}, 500);
				}
			},
			// 获取列表；获取下拉数据也获取所有列表数据
			async initListFn() {
				this.loading = true
				const {
					data: res
				} = await this.$http.getByTrailer({
					params: this.queryInfo
				})
				if (res.status !== 0) {
					return this.$message.error('获取数据失败!')
				}
				this.dataList = res.data
				this.total = res.total
				this.loading = false
				this.dockList = res.dock
				this.trailer_door_pointList = res.trailer_door_point
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize) {
				this.queryInfo.pagesize = newSize
				this.initListFn()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage) {
				this.queryInfo.pagenum = newPage
				this.initListFn()
			},
			// 删除
			async removeFn(id) {
				const confirmResult = await this.$confirm('此操作将删除这条数据是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					lockScroll: false
				}).catch(err => err)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除')
				}
				const {
					data: res
				} = await this.$http.delTrailer(id)
				if (res.status !== 0) return this.$message.error('删除失败！')
				this.$message.success('删除成功！')
				// 重新请求列表数据
				this.initListFn()

			},

			//区间删除
			async delSelectConfirm() {
				if (this.delSelectForm.start == '' && this.delSelectForm.end == '') {
					return this.$message.warning('请填写ID！')
				}
				const confirmResult = await this.$confirm('注意！此操作将批量删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					lockScroll: false
				}).catch(err => err)
				//如果确认删除，则返回值为字符串 confirm
				console.log(confirmResult)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除')
				}
				let idString = `${this.delSelectForm.start},${this.delSelectForm.end}`
				const {
					data: res
				} = await this.$http.delBatchTrailer({
					id: idString
				})
				if (res.status !== 0) {
					return this.$message.error('批量删除失败!')
				}
				this.$message.success('批量删除成功!')
				this.initListFn()
				this.delSelectDialogVisible = false
			},
			delSelectDialogClosed() {
				this.$refs.delSelectFormRef.resetFields()
			},
			async updateFn(id) {
				const {
					data: res
				} = await this.$http.byIdTrailer(id)
				if (res.status !== 0) {
					return this.$message.error('获取数据失败!')
				}
				this.editForm = res.data
				this.editDialogVisible = true
			},
			async editConfirm() {
				const {
					data: res
				} = await this.$http.editTrailer(this.editForm)
				if (res.status !== 0) {
					return this.$message.error('修改失败!')
				}
				this.$message.success('修改成功!')
				this.editDialogVisible = false
				this.initListFn()
			},
			editDialogClosed() {
				this.$refs.editFormRef.resetFields()
			}


		}
	}
</script>

<style lang="less" scoped>
	.header-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>